import Controller from "./bulkScripts.controller";
import template from "./bulkScripts.html";

const bulkScripts = {
  template,
  controller: Controller,
};

export default bulkScripts;



// WEBPACK FOOTER //
// ./src/pages/bulkScripts/bulkScripts.component.js